module.exports = __webpack_public_path__ + "static/media/spot1.aee76573.png";